import { Wrapper, Search, Separator, Total, Showing, DefaultActions, GridToggles } from '@/components/Grid/components/header/Heading';
import { GridProvider, useBuildGrid, DefaultGrid } from '@Components/Grid';

import { useIpBlacklistStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function IpBlacklistGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid filters={null}
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null} />
    </Wrapper>}
  />
}

export default function IpBlacklistGridLayout() {
  return <GridProvider store={useIpBlacklistStore()}>
    <IpBlacklistGrid />
  </GridProvider>
}
